import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Cookies } from 'react-cookie';
import 'antd/dist/antd.css';

import App from './App';
import configureStore from './redux/configureStore';
import { initialRegisterState } from './redux/reducers/registerState';
import reportWebVitals from './reportWebVitals';
import Register from './containers/Register';
import axios from 'axios';
import './index.scss';

(function (window) {
  class asinzenJs {
    tracking = false;
    cookies = new Cookies();
    constructor() {}

    registerForm = (container, options = {}) => {
      const searchParams = new URLSearchParams(window.location.search);
      const type = searchParams.get('registerFrom');
      const store = configureStore({
        registerState: {
          ...initialRegisterState,
          ...options,
          type: type ? type.toUpperCase() : options.type || 'AZINSIGHT',
        },
      });

      ReactDOM.render(
        <React.StrictMode>
          <App>
            <Provider store={store}>
              <Register />
            </Provider>
          </App>
        </React.StrictMode>,
        container
      );
    };

    trackingEventListener = (e) => {
      if (e.data && e.data.event && e.data.event === 'tracking') {
        this.postTrackingData(e.data.payload);
      }
    };

    track = () => {
      this.tracking = true;
      let cookieId = null;
      const paramValue = new URLSearchParams(window.location.search).get('cid');
      const cookieValue = this.cookies.get('_az_track');
      if (paramValue) {
        cookieId = paramValue;
        /** var b=new URLSearchParams(window.location.search),a=b.get("cid");a&&(document.cookie="_az_track="+a+";")*/
        this.cookies.set('_az_track', cookieId);
      } else if (cookieValue) {
        cookieId = cookieValue;
      }
      this.postTrackingData({
        type: 'hit',
      });
      window.addEventListener('message', this.trackingEventListener);
    };

    untrack = () => {
      this.tracking = false;
      window.removeEventListener('message', this.trackingEventListener);
    };

    postTrackingData = async (payload) => {
      try {
        const cid = this.cookies.get('_az_track');
        if (!cid) {
          return;
        }
        await axios.post(
          `${process.env.REACT_APP_TRACKING_API}/trackings`,
          { cid, ...payload },
          {
            headers: {
              'Content-type': 'application/json',
            },
          }
        );
      } catch (e) {
        console.log(e);
      }
    };
  }
  window.asinzenJs = new asinzenJs();
  window.document.documentElement.setAttribute('translate', 'no');
})(window);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
